import { render } from "./about-nconsulting.vue?vue&type=template&id=6b0f628d&scoped=true"
import script from "./about-nconsulting.vue?vue&type=script&lang=js"
export * from "./about-nconsulting.vue?vue&type=script&lang=js"

import "./about-nconsulting.vue?vue&type=style&index=0&id=6b0f628d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0f628d"]])

export default __exports__